/**
 * Created by Miguel on 23/05/2017
 */
import { Component, OnInit,   } from '@angular/core';
import {UserService} from "../../../services/user.service";
import { AppDataService }  from '../../../services/app-data.service';
import { CompanyService }  from '../../../services/company.service';
import { WalletService }  from '../../../services/wallet.services';
import { ItemBean } from '../../../beansts/item.bean';
import { SpacialBean } from '../../../beansts/spacial.bean';
import { TranslationService } from '../../../services/translation.service';
import { Door } from '../../../beansts/itens/door.bean';
import { NotificationBean } from '../../../beansts';

declare var $ : any;
declare var Swal: any
declare let solanaWeb3:any
@Component({
    selector : 'container-modal',
    templateUrl:'container-modal.html',
    providers  : [],
})
export class ContainerModal implements OnInit {
  public list;
  public containerList;
  public itemGroupList;
  public container=null;
  public ground=false;
  public groundList;
  public groundName='Chão';
  public containerImg='/assets/game-ui/bag/bag.png'

  public nfts;
  public pubKey=null
  public connection;

  public tell=false;
  public paint;
  public equipChanged={};
  public containerName='Container';
  public title='Clique para usar'

  public ctx;
  public canvas;

  public recipe;

  public mode=1;
  public voidImage
  public MAXQUANTITY=10;
  public gender='male';
  public skin ='rgb(255, 0, 0,.2)';
  public shirt='rgb(255, 0, 0,.6)';
  public pants='rgb(0, 0, 255,.2)';
  public head='rgb(0, 0, 0,1)'
  public shoes='rgb(0, 0, 0,1)';
  public bodyTypeUrl
  public headTypeUrl
  public chestTypeUrl
  public legsTypeUrl
  public feetTypeUrl
  public bufferImage;
  public bufferName;
  public avatar;
  public admin=true;
  public allLoaded=false;
  public wallet

    public ngOnInit() : any {
      this.list = new Array(25).fill({'name':this.translate.instant('CONTAINER_MODAL_14'),thumbnail:'/assets/avatars/black.png',quantity:0})
      this.containerList = new Array(25).fill({'name':this.translate.instant('CONTAINER_MODAL_14'),thumbnail:'/assets/avatars/black.png',quantity:0})


      if (!this._appData.userEventContainer){
        this._companyService.getUserContainerRef().get().then((cdata)=>{
            let clist=[];
            cdata.forEach(c=>{
              let item=new ItemBean();
              item.parse(c.data())
              clist.push(item)
            })
            this._appData.userEventContainer=clist;
          })

      }
    }


    public change() {

      this.mode=1;
      this.list = new Array(25).fill({'name':this.translate.instant('CONTAINER_MODAL_14'),thumbnail:'/assets/avatars/black.png',quantity:0})
      this.sendIframeMessage({kind:'getPosition',params:''},'gameFrame')
      if (!this._appData.containerWallet) return;
      //checkout if i have a usercontainer and garantee all is ok with images
      if (!this._appData.userEventContainer){
        this._companyService.getUserContainer(true)
      }
      else{

        let i=0
        //garantee images are on memory
 /*       this.avatar=this._companyService.getAvatar();
        //make sure i have my body and head on memory
        let body=this._appData.instagramUser.bodyColor
        if (!body) body="white";
        let gender= this._appData.instagramUser.gender;
        if (!gender) gender="male"
        this.bodyTypeUrl= this.avatar[gender]['body']
        this.getImage(this.bodyTypeUrl,'BODY')
*/

        //check wallet

          if (this._appData.containerWallet){
            /*this._walletService.getBalance(this._appData.instagramUser).subscribe(val=>{
              let balance=val.json()
              let id=this._appData.userEventContainer.findIndex((obj => obj.tokenId == "SOL"));
              this._appData.userEventContainer[id].quantity=balance.balance;
              this.list[0]=this._appData.userEventContainer[id]
            });*/
            /*this._walletService.getBalance(this._appData.instagramUser).subscribe(val=>{
              if (val.status==200){
                let b=val.json()
                this._appData.balance=b.value;
                if (b.value<1000){
               //   Swal.fire({title:'Sem energia',text:'Sua carteira está sem fundos. Busque o banco no jogo para adicionar fundos na carteira ou transfira solanas para ela.'})
                }
              }
              else{
                Swal.fire({title:'Sem energia',text:'Sua carteira está sem fundos. Busque o banco no jogo para adicionar fundos na carteira ou transfira solanas para ela.'})
              }
            })*/
            this._walletService.getTokenBalance('user',this._appData.instagramUser.uid).subscribe(val=>{
              let vet=val.json();
              let lid=0;
              this.nfts=[]
              vet.forEach(element => {
                let address=element.mint_address
                let amount=element.ui_amount
                let recArr=this._appData.eventRecipes.filter((val)=>{
                  return val.id==address
                })
                let recipe=recArr[0];
                if (recipe){
                  let item=recipe.toItem();
                  if (recipe.kind=='coin'){
                    item.quantity=amount
                  }
                  else{
                    item.quantity='';
                  }
                  this.list[lid]=item;
                  lid++;
                }
                else{
                  //nft
                  this.nfts.push(element.mint_address)
                }
              });
              //add building Terrain NFT
              let recArr=this._appData.eventRecipes.filter((val)=>{
                return val.id=='EHEZapCQKxhBBuRRLFnssNQbCaVHv2XR7LAEryLx5ENc'
              })
              let recipe=recArr[0];
              if (recipe){
                let item=recipe.toItem();
                item.quantity=''
                this.list[lid]=item;
                lid++;
              }
              //add Terrain NFT
              recArr=this._appData.eventRecipes.filter((val)=>{
                return val.id=='9JQWPtZtNfsoHK1764ZX9oQHR9Q8hJ7MCSjr5ybW6pWP'
              })
              recipe=recArr[0];
              if (recipe){
                let item=recipe.toItem();
                item.quantity=''
                this.list[lid]=item;
                lid++;
              }
                              //make sure equiped itens are on memory as well
                              this.resetItemList();
                              //need to make sure all itens in the bag have images
                              this.confirmImages(false);
                              //SHOW MY CHARACTER ON CANVAS
                              //startAnimation();
                              this.redraw()
            });;




          }
          else{

          }


      }


      this.ground=false;
      this.container=null;




    }
    public createItemFromNFT(newnft){
      let item=new ItemBean();
      item.quantity=1;
      item.name=newnft.name
      item.thumbnail=newnft.image
      item.owner=this._appData.instagramUser.uid;
      item.objectId=newnft.mint;
      item.description=newnft.description
      item.masterpiece=true;

      if (item.src){
        //pattern for terrain: "https://sojustica-11662.firebaseio.com/nfts/1658368951231.json"
        //pattern for building:
        //pattern for recipe:
        let idx=item.src.indexOf('EHEZapCQKxhBBuRRLFnssNQbCaVHv2XR7LAEryLx5ENc')//building
        if (idx>0){
          item.tokenId='EHEZapCQKxhBBuRRLFnssNQbCaVHv2XR7LAEryLx5ENc'
          item.action='terrain'
        }
        else{
          item.action='terrain'
          item.masterpiece=true;
          item.tokenId='9JQWPtZtNfsoHK1764ZX9oQHR9Q8hJ7MCSjr5ybW6pWP'
        }
        item.masterpiece=true;

      }

      return item

    }
    constructor( public _appData : AppDataService,public translate: TranslationService,public _companyService : CompanyService,public _walletService : WalletService,public _auth : UserService) {
    }



    public resetItemList(){
//      this.list = new Array(25).fill({'name':'vazio',thumbnail:'/assets/avatars/black.png',quantity:0})
      let i=0;
      this._appData.userEventContainer.forEach(val=>{
        if (!val.quantity) {val.quantity=1;}
        if (val.equipped){
          if (val.where=='legs'){
            this.legsTypeUrl=val
            this.getImage(val.src,val.objectId);
          }
          if (val.where=='chest'){
            this.chestTypeUrl=val
            this.getImage(val.src,val.objectId);

          }
          if (val.where=='feet'){
            this.feetTypeUrl=val
            this.getImage(val.src,val.objectId);
          }
          if (val.where=='head'){
            this.headTypeUrl=val
            this.getImage(val.src,val.objectId);
          }

        }
      })

    }
    /*
    public startAnimation() {
      let animationInterval;
      let containerSpritesheet = document.getElementById("inventory-user-image");
      let widthOfcontainerSpritesheet = 1472;
      let widthOfEachSprite = 184;

      var position = widthOfEachSprite; //start position for the image
      const speed = 100; //in millisecond(ms)
      const diff = widthOfEachSprite; //difference between two sprites

      animationInterval = setInterval(() => {
        containerSpritesheet.style.backgroundPosition = `-${position}px 0px`;

        if (position < widthOfcontainerSpritesheet) {
          position = position + diff;
        } else {
          //increment the position by the width of each sprite each time
          position = widthOfEachSprite;
        }
        //reset the position to show first sprite after the last one
      }, speed);
    }*/
    ///////////////////ALL ABOUT DRAWING//////////////
    public redraw() {
      let canvas
      let ctx
      let mergedImages=[];
      if (!this.ctx){
        this.canvas = $("#containerSpritesheet").get(0);
        this.ctx = this.canvas.getContext("2d");
      }
      ctx=this.ctx;
      canvas=this.canvas;

      // start over
      ctx.clearRect(0, 0, canvas.width, canvas.height);
          //body
      let img = this.getImage(this.bodyTypeUrl,'BODY')
      if (img==null) return false;
      this.drawImage(ctx, img,this.skin)

      let src=null;
      if (this.headTypeUrl){
        src=this.headTypeUrl.src;
        img = this.getImage(src,this.headTypeUrl.objectId)
        if (img==null) return false;
        this.drawImage(ctx, img,this.headTypeUrl.color)
      }
      if (this.chestTypeUrl){
        src=this.chestTypeUrl.src
        img = this.getImage(src,this.chestTypeUrl.objectId)
        if (img==null) return false;
        this.drawImage(ctx, img,this.chestTypeUrl.color)
      }
      if (this.legsTypeUrl){
        src=this.legsTypeUrl.src
        img = this.getImage(src,this.legsTypeUrl.objectId)
        if (img==null) return false;
        this.drawImage(ctx, img,this.legsTypeUrl.color)
      }
      if (this.feetTypeUrl){
        src=this.feetTypeUrl.src
        img = this.getImage(src,this.feetTypeUrl.objectId)
        if (img==null) return false;
        this.drawImage(ctx, img,this.feetTypeUrl.color)
      }
      this.tell=true;
      return true;
  }
  public confirmImages(shouldSave){
    let confirmed=true;
    let img = this.getImage(this.bodyTypeUrl,'BODY')
    if (img==null) confirmed=false;
    this._appData.userEventContainer.forEach(element => {
      if (element.action=='equip' && element.src){
        img=this.getImage(element.src,element.objectId)
        if (img==null) confirmed=false;
      }
    });
    if (!confirmed){
      setTimeout(()=>this.confirmImages(shouldSave),3000)
    }
    else{
      if (!this.allLoaded){
        this.allLoaded=true;
        console.log('Imagem carregada','Imagens de equipaveis carregados')
      }
      if (shouldSave){
        this.saveNewStyle(false)
        Swal.fire(this.translate.instant('CONTAINER_MODAL_10'),this.translate.instant('CONTAINER_MODAL_11'))
        setTimeout(()=>this.saveNewStyle(true),3000)
      }
    }
  }
  public getImage(imgRef,imgId) {
      if (this._appData.images[imgId])
          return this._appData.images[imgId];
      else {
          // Load image if not in cache
          var img = new Image();
          img.src = imgRef;
          img.onload = ()=>{
            this._appData.images[imgId] = img;
          }
          return null;
      }
  }



  public getImage2(imgRef, callback) {
      if (this._appData.images[imgRef]) {
          callback(this._appData.images[imgRef]);
          return this._appData.images[imgRef];
      } else {

          // Load image if not in cache
          var img = new Image();
          img.src = imgRef;
          img.onload = function() { callback(img) };
          this._appData.images[imgRef] = img;
          return img;
      }
  }

  // Do not stop running all javascript if image not available
public drawImage(ctx, img,color) {
    try {
        img.setAttribute('crossorigin', 'anonymous');

        let bcanvas = $("#buffer").get(0);
        bcanvas.style.visibility='hidden'
        bcanvas.width=1008
        bcanvas.height=1360
        let bctx = bcanvas.getContext("2d");
        bctx.globalCompositeOperation='source-over';
        bctx.drawImage(img, 0, 0);
        bctx.globalCompositeOperation='source-atop';
        bctx.fillStyle = color;
        bctx.fillRect(0,0,bcanvas.width,bcanvas.height);

        ctx.globalCompositeOperation='source-over';
        ctx.drawImage(bcanvas, 0, 0,bcanvas.width,bcanvas.height,0,0,bcanvas.width,bcanvas.height);

      } catch(err) {
        console.error("Error: could not find " + img.src+ err);
    }
  }
  public saveNewStyle(save){
      //update user on game and on database
      if (! this.canvas){
        this.canvas = $("#containerSpritesheet").get(0);
        this.ctx = this.canvas.getContext("2d");
      }
        this.canvas.style.visibility='visible'
        this.canvas.width=1008
        this.canvas.height=1360
        let drawed=this.redraw();
        if (drawed){

          if (save){
            var dataurl = this.canvas.toDataURL("image/png")
            let filename: string = 'avatar.png';

            var arr = dataurl.split(','),
            mime = arr[0].match(/:(.*?);/)[1],
            bstr = atob(arr[1]),
            n = bstr.length,
            u8arr = new Uint8Array(n);
            while(n--){
                u8arr[n] = bstr.charCodeAt(n);
            }
            let pngFile=new File([u8arr], filename, {type:"image/png"});
            this._auth.uploadToFirebase(pngFile, filename, 'userprofile/'+this._appData.instagramUser.uid+'/avatar').subscribe(snapshot =>{
              snapshot.ref.getDownloadURL().then(url => {
                this.sendIframeMessage({kind:'updateUserStatus',params:{avatar:url}},'gameFrame')
                this._companyService.updateUserProperty("avatar",url,this._appData.instagramUser)
                if (this.equipChanged){
                  for (let prop in this.equipChanged){
                      let val= this.equipChanged[prop]
                      this._companyService.getUserContainerRef().doc(val.objectId).set(val.toDB());
                  }
                  this.equipChanged=null;
                }
                this._appData.instagramUser.avatar=url;
    //            window.location.reload()
              })

            });
          }
        }
    }
    public sendIframeMessage(messageKind,frame){
      var iframe = document.getElementById(frame);
      if (iframe == null) return;
      var iWindow = (<HTMLIFrameElement>iframe).contentWindow;
      iWindow.postMessage(messageKind, "*");
    }
    public swap(){
      if (this.mode==3 || this.mode==2){
        this.containerImg=this.bufferImage;
        this.containerName=this.bufferName;
        this.mode=1
      }
      else{
        this.containerImg='/assets/game-ui/bag/bag.png'
        this.containerName=this.translate.instant('WALLET')
        this.mode=3
      }
    }
    public makeMyWallet(){
      this._walletService.getCreateWallet('user',this._appData.instagramUser.uid).subscribe(val=>{
        if (val.status==200){
          this.wallet=true;
          this.change();
        }
        else{
          this.wallet=false;
        }
      })
    }

    public unequipItem(item){
      Swal.fire({title:this.translate.instant('CONTAINER_MODAL_12'),text:this.translate.instant('CONTAINER_MODAL_13'),showCloseButton: true,
      confirmButtonText: "this.translate.instant('YES')",
      cancelButtomText:"this.translate.instant('NO')",
      showCancelButton: true,
      }).then((result) => {
      if (result.value) {
        let myitens=this._appData.userEventContainer;
        let itemToequip;
        //make sure i have my body and head on memory
        //basis collected
        switch (item.where){
          case "chest": {
            this.chestTypeUrl=null;
            break;
          }
          case "legs": {
            this.legsTypeUrl=null;
             break;
          }
          case "feet": {
            this.feetTypeUrl=null;
            break;
          }
          case "head": {
            this.headTypeUrl=null;
            break;
          }
        }
        for (let idx=0;idx<myitens.length;idx++){//para cada item no meu inventory
            if (myitens[idx].objectId==item.objectId){//se o item sendo visto é o item desequipado
              //removeit
              myitens[idx].equipped=false;
              this._companyService.getUserContainerRef().doc(item.objectId).set(item.toDB());
            }
        }
        this._appData.userEventContainer=myitens;
        this.resetItemList();
        this.confirmImages(true);
      }

    })


    }


    public equipItem(item){
      let myitens=this._appData.userEventContainer;
      let itemToUnequip;
      //make sure i have my body and head on memory
      //basis collected
      switch (item.where){
        case "chest": {
          itemToUnequip=this.chestTypeUrl;
          this.chestTypeUrl=item;
          break;
        }
        case "legs": {
          itemToUnequip=this.legsTypeUrl;
          this.legsTypeUrl=item;
           break;
        }
        case "feet": {
          itemToUnequip=this.feetTypeUrl;
          this.feetTypeUrl=item;
          break;
        }
        case "head": {
          itemToUnequip=this.headTypeUrl;
          this.headTypeUrl=item;
          break;
        }
     }
     if (!this.equipChanged) this.equipChanged={}
     for (let idx=0;idx<myitens.length;idx++){//para cada item no meu inventory
      if (itemToUnequip){//se eu tiver desequipado um item
        if (myitens[idx].objectId==itemToUnequip.objectId){//se o item sendo visto é o item desequipado
          //removeit
          myitens[idx].equipped=false;
          this._companyService.getUserContainerRef().doc(myitens[idx].objectId).set(myitens[idx].toDB());
        }
      }
      if (myitens[idx].objectId==item.objectId){//adicionar item
        myitens[idx].equipped=true;
        this._companyService.getUserContainerRef().doc(myitens[idx].objectId).set(myitens[idx].toDB());
      }

    }
    for (let id=0;id<this.itemGroupList.length;id++){
      let gitem=this.itemGroupList[id]
      if (gitem.objectId==item.objectId){
        if (itemToUnequip){
          this.itemGroupList[id]=itemToUnequip
        }
        else{
          this.itemGroupList[id]={'name':this.translate.instant('CONTAINER_MODAL_14'),thumbnail:'/assets/avatars/black.png',quantity:0}
        }
      }
    }
    this._appData.userEventContainer=myitens;
    this.resetItemList();
    this.confirmImages(true);
  }
    public drawEquipedItem(){
      this.equipChanged=false;
      if (!this._appData.images){
        this._appData.images={}
      }

      this.saveNewStyle(true);

    }
    public clickContainerItem(item){
       //take item out of inventory to the container
      if (item.action=='equip'){
        this.getImage(item.src,item.objectId);
      }
      this._companyService.removeFromContainer(this.container,item).then(val=>{
          this.containerList=this.containerList.filter((it)=>{
            return (item.objectId!=it.objectId)
          })
      })
      this._companyService.addToUserContainer(this._appData.instagramUser,item.toDB()).then(val=>{
          this.list.unshift(item)
          this._appData.userEventContainer=this.list;
          this.confirmImages(false);
      })

    }

    public doPaint(item){
      if (!item.color) {
        item.color="rgb(0,0,0,0)"
        item.thumbnailSrc=item.thumbnail;
      }
        if (item.equipped){
          Swal.fire({title:this.translate.instant('CONTAINER_MODAL_15'),text:this.translate.instant('CONTAINER_MODAL_16')})
        }
        else{
          this.paint=false;
          $('#containerModal').modal('hide')
          this._appData.selectedItem=item;
          $('#paintModal').modal("show")
          $('#paintModalClick').click()
          return;
        }

    }
    public clickItem(item){

      let chestId=this.chestTypeUrl ? this.chestTypeUrl.objectId : null;
      let legsId=this.legsTypeUrl ? this.legsTypeUrl.objectId : null;
      let feetId=this.feetTypeUrl ? this.feetTypeUrl.objectId : null;
      let headId=this.headTypeUrl ? this.headTypeUrl.objectId : null;

      this._appData.object=item
      if (item.action=='equip'){
        this.getImage(item.srcm,item.objectId);
      }
      if (item.kind=='coin'){
        return;
      }
      if (this.container) {
        //take item out of inventory to the container
        Swal.fire({
          title:this.translate.instant('CONTAINER_MODAL_17'),
          text:this.translate.instant('CONTAINER_MODAL_18'),
          confirmButtonText: this.translate.instant('TRANSFER'),
          cancelButtonText:this.translate.instant('CANCEL'),
          showCloseButton: true,
          showCancelButton: true,
          focusConfirm: false,
          }).then((result) => {
            if (result.dismiss=='backdrop') {}
            else if (result.dismiss=='close') {}
            else if (result.dismiss=='cancel'){}
            else{
              this._companyService.removeFromUserContainer(this._appData.instagramUser,item).then(val=>{
                  this.list=this.list.filter((it)=>{
                    return (item.objectId!=it.objectId)
                  })
                this._appData.userEventContainer=this.list;
              })
              this._companyService.addToContainer(this.container,item.toDB()).then(val=>{
                  this.containerList.unshift(item)
              })

            }
        });


      }
      else  {
        if (item.location!='bag'){
          Swal.fire(this.translate.instant('CONTAINER_MODAL_19'),this.translate.instant('CONTAINER_MODAL_20'))
          return;
        }

        if (item.recipeId == item.objectId){
          let recipeArr=this._appData.eventRecipes.filter(val=>{
            return val.id==item.baseItem
          })
          let recipe=recipeArr[0]
          Swal.fire({
              title:this.translate.instant('CONTAINER_MODAL_21'),
              text:this.translate.instant('CONTAINER_MODAL_22')+recipe.name+'?',
              confirmButtonText: this.translate.instant('YES'),
              cancelButtonText:this.translate.instant('NO'),
              showCancelButton: true,
              showCloseButton: true,
            }).then((result) => {
              if (result.value) {
                item=recipe.toItem();
                this._companyService.getUserContainerRef().doc(item.objectId.toString()).set(item.toDB()).then(v=>{
                  setTimeout(()=>{
                    this._companyService.getUserContainer(true);
                    this.mode=1;
                  },3000)

                })
                //abrir celular no espaco

              }
            })
          return;

        }
        if (this.mode==2 || item.masterpiece){
          if (this.paint){
            this.paint=false;
            this.doPaint(item);
          }
          else{
            let date=new Date();
            let milis=date.getTime()
            Swal.fire({
              title: this.translate.instant('CONTAINER_MODAL_23'),
              icon: "warning",
              showConfirmButton: false,
              showCloseButton: true,
              html: `
                <p>O que você deseja fazer?</p>
                <div>
                  <button id="itemUseClick`+milis+`" class="btn btn-primary" >Utilizar</button>
                  <button id="itemShareClick`+milis+`" class="btn btn-danger" >Compartilhar</button>
                  <button id="itemGroundClick`+milis+`" class="btn btn-secondary" >Pro chão</button>
                </div>`
            });
            $(document).on('click', '#itemUseClick'+milis, ()=> {
              Swal.close();
              if (!item.masterpiece){
                this.useItem(item);
              }
              else{
                this._walletService.getProperties(item).subscribe(val=>{
                  let vdata=val.json();
                  item.properties=vdata.properties;
                  this.useItem(item);
                })

              }

            });
            $(document).on('click', '#itemShareClick'+milis, ()=> {
              Swal.close();
              if (item.action=="room"){
                Swal.fire({title:this.translate.instant('FAIL'),text:this.translate.instant('CONTAINER_MODAL_24')})
                return;
              }
              let date=new Date();
              let time=date.getTime();
              let name=this._appData.instagramUser.full_name;
              let notification={
                event:this._appData.event.id,
                time:time,
                senderUid:this._appData.instagramUser.uid,
                senderName:name,
                senderThumbnail:'',
                subject:this.translate.instant('CONTAINER_MODAL_25'),
                message:name+this.translate.instant('CONTAINER_MODAL_26'),
                kind:'seeLink',
                link:item.param.link,
                read:false,
                action:'',
                answer:''
              }

              if (this._appData.page=='meeting'){
                this._companyService.addRoomNotification(this._appData.room,notification)
              }
              else{
                if (this._appData.localConference){
                  this._appData.localConference.forEach(element => {
                    if (element.uid==this._appData.instagramUser.uid){
                      Swal.fire({
                        title:this.translate.instant('CONTAINER_MODAL_27'),
                        text:this.translate.instant('CONTAINER_MODAL_28'),
                        confirmButtonText: this.translate.instant('YES'),
                        cancelButtonText:this.translate.instant('NO'),
                        showCancelButton: true,
                        showCloseButton: true,
                      }).then((result) => {
                        if (result.value) {
                          //abrir celular no espaco
                          this._companyService.openExternalLink(notification.link,false)

                        }
                      })
                    }
                    else{
                      this._companyService.sendNotificationToSomeoneElse(this._appData.event,this._appData.instagramUser,element,notification.subject,notification.message,'seeLink',notification.link,false)
                    }
                  });
                }
                else{
                  this.sendIframeMessage({"kind":"shareItemToUsers","item":item},'gameFrame')
                }
              }
            });
            $(document).on('click', '#itemGroundClick'+milis, ()=> {
              Swal.close();
              if (item.equiped){
                Swal.fire({title:this.translate.instant('CONTAINER_MODAL_15'),text:this.translate.instant('CONTAINER_MODAL_29')})
              }
              else if (item.undroppable){
                Swal.fire({title:this.translate.instant('FAIL'),text:this.translate.instant('CONTAINER_MODAL_30')})
              }
              else if (this._appData.room.id.indexOf('noroom')>=0){
                Swal.fire({title:this.translate.instant('FAIL'),text:this.translate.instant('CONTAINER_MODAL_31')})
              }
              else{
                this.removeItem(item);
              }
            });

          }
        }
        else{
          this.mode=2;
          this.containerName=item.name;
          this.itemGroupList = new Array(25).fill({'name':this.translate.instant('CONTAINER_MODAL_14'),thumbnail:'/assets/avatars/black.png',quantity:0})
          let quantity=item.quantity;
          let lastIndex=0
          for (let i=0;i<this._appData.userEventContainer.length;i++){
            let it=this._appData.userEventContainer[i]
            if (it.tokenId==item.tokenId){
              if (!it.equipped && it.location!='ground'){
                it.quantity=1;
                this.itemGroupList[lastIndex]=it
                lastIndex++;
              }
              quantity--;
              if (quantity==0){
                break;
              }
            }
          }
          if (this.nfts.length>0){
            this._walletService.getDatabaseNFTs().subscribe(dbRet=>{
              let nftVet=dbRet.json();
              this.nfts.forEach(n=>{
                let equal=nftVet.filter(n1=>{
                  return n1.mint==n;
                })
                if (equal[0]){
                  let uri=equal[0].uri;
                  if (uri){
                    if (uri.indexOf('sojusti')>0){//nft server container requirement
                      let tokenId='9JQWPtZtNfsoHK1764ZX9oQHR9Q8hJ7MCSjr5ybW6pWP';
                      let idx=uri.indexOf('9JQWPtZtNfsoHK1764ZX9oQHR9Q8hJ7MCSjr5ybW6pWP');//search for token map terrain token
                      if (idx>0){
                        tokenId='9JQWPtZtNfsoHK1764ZX9oQHR9Q8hJ7MCSjr5ybW6pWP'
                      }
                      idx=uri.indexOf('EHEZapCQKxhBBuRRLFnssNQbCaVHv2XR7LAEryLx5ENc');//search for token map terrain token
                      if (idx>0){
                        tokenId='EHEZapCQKxhBBuRRLFnssNQbCaVHv2XR7LAEryLx5ENc'
                      }
                      if (tokenId==item.tokenId){
                        this._walletService.getNFTs(n).subscribe(r=>{
                          let newnft=r.json();
                          let item=this.createItemFromNFT(newnft)
                          this.itemGroupList[lastIndex]=item;
                          lastIndex++;
                        })
                      }

                    }

                  }
                }
                else{
                  this._walletService.getNFTs(n).subscribe(r=>{
                    let newnft=r.json();
                    let item=this.createItemFromNFT(newnft)
                    this.itemGroupList[lastIndex]=item;
                    lastIndex++;
                  })

                }
              })
            })
          }

         /* if (quantity>0){//extra itens should exist
            let recipeArr=this._appData.eventRecipes.filter(val=>{
              return val.id==item.recipeId
            })
            let recipe=recipeArr[0]
            for (let i=0;i<quantity;i++){
              let it=recipe.toItem();
              it.objectId=item.tokenId
              it.baseItem=recipe.baseItem
              this.itemGroupList[lastIndex+i]=it;
            }
          }*/


        }

      }

    }
    public calculateItemPosition(item){
      let myx=this._appData.instagramUser.position.x
      let myy=this._appData.instagramUser.position.y
      let idx=0;
      if (this._appData.room.backgroundPhoto){
        this._appData.room.backgroundPhoto.forEach(photo=>{
          if  ( (myx> (photo.x-photo.ra)) && (myx < (photo.x+photo.ra)) && (myy < (photo.y+photo.ra)) && (myy> (photo.y-photo.ra)) ){
            item.space=idx
            item.position=new SpacialBean()
            item.position.x=photo.x;
            item.position.y=photo.y;
            item.position.z=0;
          }
          idx++;
        })
      }
      else{
        item.position=new SpacialBean()
        if (this._appData.instagramUser.position.x){
          if ((this._appData.instagramUser.position.x-this._appData.room.defaultPlace.x)>500){
            item.position.x=this._appData.room.defaultPlace.x
            item.position.y=this._appData.room.defaultPlace.y
            item.position.z=0 
          }
          else{
            item.position.x=this._appData.instagramUser.position.x
            item.position.y=this._appData.instagramUser.position.y
            item.position.z=0   
          }
        }
        else{
          item.position.x=this._appData.room.defaultPlace.x
          item.position.y=this._appData.room.defaultPlace.y
          item.position.z=0
        }

      }
      return item;
    }
    public removeItem(item){

      //ask position
      this.sendIframeMessage({"kind":"getPosition"},'gameFrame')
      Swal.fire({title:this.translate.instant('CONTAINER_MODAL_32'),
          text:this.translate.instant('CONTAINER_MODAL_33'),
          confirmButtonText: this.translate.instant('YES'),
          cancelButtonText:this.translate.instant('NO'),
          showCloseButton: true,
          showCancelButton: true,
          focusConfirm: false,
          }).then((result) => {
            if (result.dismiss=='backdrop') {}
            else if (result.dismiss=='close') {}
            else if (result.dismiss=='cancel'){}
            else{
                  item.owner=this._appData.instagramUser.uid;
                  item=this.calculateItemPosition(item);
                  if (!item.masterpiece){
                    //put item on room database
                    item.room=this._appData.room.id;
                    item.location='ground';
                    this._companyService.getUserRoomItemRef(this._appData.room.id).doc(item.objectId.toString()).set(item.toDB()).then( v=>{
                      //update item on inventory so that it looks unavailable
                      this._companyService.getUserContainerRef().doc(item.objectId.toString()).delete().then(v=>{
                        this._companyService.getUserContainer(true);
                        this.itemGroupList=this.itemGroupList.filter((v)=>{
                          return v.objectId!=item.objectId;
                        })
                      })
                    })
                  }
                  else{
                    Swal.fire({title:this.translate.instant('FAIL'),text:this.translate.instant('CONTAINER_MODAL_34')})
                  }



            }
      })
    }
    public reload(idx){
      if (idx==2){
        this.mode=2;
        let item=this._appData.object;
        this.itemGroupList = new Array(25).fill({'name':this.translate.instant('CONTAINER_MODAL_14'),thumbnail:'/assets/avatars/black.png',quantity:0})
        let lastIndex=0
        this._companyService.getUserContainerRef().where('tokenId','==',item.tokenId).get().then(v=>{
          v.forEach(itD=>{
            let it=itD.data();
            if (!it.equipped && it.location!='ground'){
              let item=new ItemBean();
              item.parse(it);
              this.itemGroupList[lastIndex]=item;
              lastIndex=lastIndex+1;
            }
          })
        })
      }
    }
    public useItem(item){


      switch (item.action){
        case "link":{
          this._companyService.openExternalLink(item.param.link,true);
          break
        }
        case "terrain":{
          let room='';
          if (item.param){
            room=item.param.room
          }
          if (item.properties){
            room=item.properties.room;
          }
          if (this._appData.room.id==room){
            this._appData.object=item;
            $('#containerModal').modal("hide");
            $('#editRoomModal').modal("show");
            $('#editRoomModalClick').click();
          }
          else{
            let domain=window.location.origin
            window.location.href=domain+"/gameevent/"+item.properties.map+'?room='+room;
          }
          break;

        }
        case "key":{
          Swal.fire({title:this.translate.instant('CONTAINER_MODAL_35'),
          text:this.translate.instant('CONTAINER_MODAL_36')+ item.param.room+this.translate.instant('CONTAINER_MODAL_39'),
          confirmButtonText: this.translate.instant('CONTAINER_MODAL_23'),
          cancelButtonText:this.translate.instant('CONTAINER_MODAL_37'),
          showCloseButton: true,
          showCancelButton: true,
          focusConfirm: false,
          }).then((result) => {
            if (result.dismiss=='backdrop') {}
            else if (result.dismiss=='close') {}
            else if (result.dismiss=='cancel'){
              Swal.fire({title:this.translate.instant('CONTAINER_MODAL_38'),
              input: 'text',
              inputAttributes: {
                autocapitalize: 'off'
              },
              showCancelButton: true,
              confirmButtonText: this.translate.instant('SAVE'),
              showLoaderOnConfirm: true,
              preConfirm: (name) => {
                if (name){
                  item.name=name;
                  this._companyService.getUserContainerRef().doc(item.objectId).set(item.toDB())
                  for (let i=0;i<this._appData.userEventContainer.length;i++){
                    if (this._appData.userEventContainer[i].objectId==item.objectId){
                      this._appData.userEventContainer[i]=item
                    }
                  }
                }
              }
              })
            }
            else{
              let key=this._appData.room.id;
              if (this._appData.room.meeting){
                key=this._appData.room.father
              }
              if (item.param.room==key){
                this.closeModal();
                this._appData.object=item;
                $(`#roomMediaControlModal`).modal('show')
                $('#mediaControlChange').click();
              }
              else{
                Swal.fire({title:this.translate.instant('CONTAINER_MODAL_40'),text:this.translate.instant('CONTAINER_MODAL_41')})
              }
            }
        });
          break;
        }
        case "room":{
          if (this._appData.room.id==item.param.value){
            this.closeModal();
            $(`#roomMediaControlModal`).modal('show')
            $('#mediaControlChange').click();
          }
          else{
            Swal.fire({title:this.translate.instant('CONTAINER_MODAL_40'),text:this.translate.instant('CONTAINER_MODAL_41')})
          }
          break
        }
        case "openLink":{//open new page
          this._companyService.openExternalLink(item.param.link,true);
          break
        }
        case "game":{
          let param=item.param;
          let gameActions= param.gameActions;
          gameActions.forEach(a=>{
            if (a.kind=='moveItem'){
              let object=a.objectId;
              let position=a.position
              let rotation=a.rotation;
              this._companyService.getUserRoomItemRef(this._appData.room.id).doc(object).update({"position":position,"rotation":rotation})

            }
            if (a.kind=='notification'){
              let link=a.link;
              let recipient=a.recipient;
              let notificationKind=a.notificationKind
              let date=new Date();
              let time=date.getTime();
              let notification={
                event:this._appData.event.id,
                time:time,
                senderUid:this._appData.instagramUser.uid,
                senderName:this._appData.instagramUser.full_name,
                senderThumbnail:'',
                subject:recipient,
                message:'',
                kind:notificationKind,
                link:link,
                read:false,
                action:'',
                answer:''
              }
              this._companyService.addRoomNotification(this._appData.room,notification);
            }
          })
0



          break
        }
        case "avatarChange":{//open inside game
/*          this.sendIframeMessage({
            kind:'avatarChange',
            params:item.param,
          },'gameFrame');*/
          let date=new Date();
          let time=date.getTime();
          let notification={
            subject:this._appData.instagramUser.uid,
            avatar:item.param.avatar,
            kind:'updateUserAvatar',
            room:this._appData.room.id,
            date:time
          }
          this._companyService.addEventNotification(this._appData.event,notification)
          break
        }
        case "insideGame":{//open inside game
          this._appData.param={link:item.param.link,name:item.name}
          $('#containerModal').modal('hide')
          $('#externalLinkModal').modal('show')
          $('#externalLinkModalClick').click();
          break
        }
        case "embed":{//embending on the stream
          if (!item.param) item.param={link:''}
          let link=item.param.link;
          this._appData.param={link:link,name:item.name}

          if (!link){
            this.makeEmbedProcess(item,link)
          }
          else{
            Swal.fire({title:this.translate.instant('CONTAINER_MODAL_42'),
                      text:this.translate.instant('CONTAINER_MODAL_43'),
                      confirmButtonText:this.translate.instant('CONTAINER_MODAL_44'),
                      cancelButtonText:this.translate.instant('CONTAINER_MODAL_45'),
                      showCloseButton: true,
                      showCancelButton: true,
                      focusConfirm: false,
                      }).then((result) => {
                        if (result.dismiss=='backdrop') {}
                        else if (result.dismiss=='close') {}
                        else if (result.dismiss=='cancel'){
                          this.makeEmbedProcess(item,link)
                        }
                        else{
                            $('#containerModal').modal('hide')
                            this._companyService.openExternalLink(item.param.link,true);
                        }
                    });
          }
          break
        }
        case "modal":{
          $('#containerModal').modal('hide')
          $('#'+item.src).modal("show")
          break;
        }
        case "equip":{
          Swal.fire({title:this.translate.instant('CONTAINER_MODAL_46'),text:this.translate.instant('CONTAINER_MODAL_47'),showCloseButton: true,
            confirmButtonText: this.translate.instant('YES'),
            cancelButtomText:this.translate.instant('NO'),
            showCancelButton: true,
            }).then((result) => {
            if (result.value) {
              this.equipItem(item)
            }

          })
        break;
        }
        case "door":{
          let door=new Door();
          door.bagUseItem();
          break;
        }

        case "cellphone":{
          this._appData.toggleCellPhone=true;
          $('#containerModal').modal('hide')
          break;
        }
      }
    }
    public pickColor(){
        Swal.fire({title:this.translate.instant('CONTAINER_MODAL_48'),text:this.translate.instant('CONTAINER_MODAL_49')})
        this.paint=true;
    }

    public makeEmbedProcess(item,link){
      Swal.fire({title:this.translate.instant('CONTAINER_MODAL_50'),
      input: 'text',
      inputAttributes: {
        autocapitalize: 'off'
      },
      showCancelButton: true,
      confirmButtonText: this.translate.instant('SAVE'),
      showLoaderOnConfirm: true,
      preConfirm: (name) => {
        if (name){
          Swal.fire({title:this.translate.instant('CONTAINER_MODAL_51'),
          input: 'text',
          inputAttributes: {
            autocapitalize: 'off'
          },
          showCancelButton: true,
          confirmButtonText: 'Salvar',
          showLoaderOnConfirm: true,
          preConfirm: (login) => {
            if (!login){
              Swal.fire(this.translate.instant('FAIL'),this.translate.instant('CONTAINER_MODAL_52'))
            }
            else{
                  item.param.link=login
                  if (login.indexOf('http')<0){
                    login='https://www.'+login;
                  }
                  item.param.name=name;
                  item.name=name;
                  this._companyService.getUserContainerRef().doc(item.objectId).set(item.toDB())
                  for (let i=0;i<this._appData.userEventContainer.length;i++){
                    if (this._appData.userEventContainer[i].objectId==item.objectId){
                      this._appData.userEventContainer[i]=item
                    }
                  }
                    this.list=this._appData.userEventContainer;
                    this._appData.param={link:login,name:item.name}
                    $('#containerModal').modal('hide')
                    let mheight = window.screen.availHeight;
                    let mwidth = window.screen.availWidth;
                    let width=mwidth*60/100;
                    let height=mheight*60/100;
                    let top=mheight*0.1
                    let left=mwidth*0.1
                    window.open(login,
                    'targetWindow',
                    'toolbar=no,location=no,status=no,menubar=no,scrollbars=no,resizable=yes,width='+width+',height='+height+',top='+top+',left='+left                    );
            }

          }
        });


        }
      }
    })
    }
    public itemToMap(itemToRemove:ItemBean,position){
      			/*ITEM FORMAT:
					id - unique por item kind
					kind - link, sittable, etc
					name
					quantity
					src (parametro pra clique)"https://io2.convertiez.com.br/m/superpaguemenos/shop/products/images/32268/medium/ovo-pascoa-lacta-560g-favn22_78585.jpg"
					thumbnail
			*/
			/* DECORATION FORMAT
			  action, collision, dimensions, link, location, objectId,position,room,texture
			*/
			//preciso guardar isso na sala.
      itemToRemove.position.x=position.x;
      itemToRemove.position.y=position.y;
      itemToRemove.position.z=0;
      itemToRemove.collision=false;
      if (itemToRemove.action=='sittable') {
        itemToRemove['orientation']=0
      }
      return itemToRemove;
    }
    public useMode(){
      this.title=this.translate.instant('CONTAINER_MODAL_53')
      this.ground=false;
      this.groundList=[]
    }
    public discartMode(){
      this.title=this.translate.instant('CONTAINER_MODAL_54')
      this.ground=true;
      this.groundList=[]
      this.groundName=this.translate.instant('CONTAINER_MODAL_55')
      let position=this._appData.instagramUser.position;

    }
    public closeModal(){
      $('#containerModal').modal('hide')

    }
    public testLink(link){
      if (link.indexOf('<iframe')>=0){
        let sidx=link.indexOf('src=')
        link=link.substring(sidx+5)
        let eidx=link.indexOf('"')
        link=link.substring(0,eidx)
        return link;
      }
      else{
        return link;
      }
    }

}



// WEBPACK FOOTER //
// C:/prj/liveplanet-app-site/src/app/components/+gameevent/container/container-modal.ts